import { Text } from '@thanx/uikit/text'
import Spinner from 'components/Spinner'
import { buildTranslate } from 'locales'
import React from 'react'
import SampleCustomerRowWrapper from './SampleCustomerRowWrapper'
import './segmentDetails.scss'

const t = buildTranslate('segments.details')

interface SampleCustomersContentProps {
  recordIds: Array<number | string>
  hasMore: boolean | undefined
  isLoading: boolean
  totalCount: number | undefined
  customerCount?: number
  triggerRef: React.RefObject<HTMLDivElement>
}

const SampleCustomersContent = ({
  recordIds,
  hasMore,
  isLoading,
  totalCount,
  customerCount,
  triggerRef,
}: SampleCustomersContentProps) => {
  // totalCount is capped to the sample window; prefer the exact audience size
  const audienceCount = customerCount ?? totalCount
  if (totalCount === undefined && recordIds.length === 0) {
    return (
      <div
        className="segment-details__loading-container"
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        <div className="d-flex justify-content-center">
          <Spinner size="2x" isLoading={true} />
        </div>
        <span className="sr-only">{t('sample_customers.loading_message')}</span>
      </div>
    )
  }

  if (totalCount === 0) {
    return (
      <Text.BodyText4 color="grey70">
        {t('sample_customers.empty_state')}
      </Text.BodyText4>
    )
  }

  return (
    <div>
      <div className="segment-details__section-header">
        <Text.BodyText3
          color="grey90"
          className="segment-details__section-title"
        >
          {t('sample_customers.title')}
        </Text.BodyText3>
      </div>
      {audienceCount !== undefined && (
        <div className="mb-3">
          <Text.BodyText4 color="grey70">
            {t('sample_customers.customer_count', {
              count: audienceCount.toLocaleString(),
            })}
          </Text.BodyText4>
        </div>
      )}

      <div className="table-responsive">
        <table className="table table-borderless">
          <tbody className="segment-details__table-body">
            {recordIds.map((customerId, index) => (
              <SampleCustomerRowWrapper
                key={customerId}
                customerId={String(customerId)}
                index={index}
                isLast={hasMore === false && index === recordIds.length - 1}
              />
            ))}
          </tbody>
        </table>
      </div>

      {hasMore && (
        <div
          ref={triggerRef}
          className="d-flex align-items-center justify-content-center px-5 py-3 w-100 segment-details__infinite-scroll-trigger"
          data-testid="infinite-scroll-trigger"
        >
          {isLoading && (
            <>
              <Spinner size="lg" isLoading={true} />
              <span className="text-grey-70 segment-details__load-more-text">
                {t('sample_customers.load_more')}
              </span>
            </>
          )}
        </div>
      )}
    </div>
  )
}

export default SampleCustomersContent
